import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { clog } from "../lib/utils";

function NotionCallBackUrl() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(true);
  const getNotionAccessToken = async (code, state) => {
    // clog(id);
    // let notion_access = JSON.parse(localStorage.getItem("notion_access") || "false");
    // if(notion_access){
    //   let navigation= "/integration-marketing";
    //     setTimeout(() => {
    //       navigate(navigation);
    //     }, 100);
    //     return
    // }
    setloading(true);
    try {
      const response = await axios({
        url: `${
          process.env.REACT_APP_BASE_SIGNIN_URL
        }/notion/callback?code=${code}&state=${state}&user_id=${
          JSON.parse(localStorage.getItem("login_data"))?.resp_user?.id
        }`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        // window.open(response.data.url, "_self");
        localStorage.setItem("notion_access", JSON.stringify(true));
        let navigation = "/integration-marketing";
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      } else {
        localStorage.setItem("notion_access", JSON.stringify(false));
        let navigation = `/integration-marketing?error=${response.data.message}`;
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");
    let state = searchParams.get("state");
    let error = searchParams.get("error");
    let notion_access = JSON.parse(
      localStorage.getItem("notion_access") || "false"
    );
    if (code && !error) {
      getNotionAccessToken(code, state);
    } else {
      setloading(false);
      localStorage.setItem("notion_access", JSON.stringify(false));
      let navigation = `/integration-marketing?error=${error}`;
      setTimeout(() => {
        navigate(navigation);
      }, 100);
    }
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}
    </div>
  );
}

export default NotionCallBackUrl;
